import { render, staticRenderFns } from "./ApproveOrDeclineGrant.vue?vue&type=template&id=5bcd60ea&scoped=true&"
import script from "./ApproveOrDeclineGrant.vue?vue&type=script&lang=ts&"
export * from "./ApproveOrDeclineGrant.vue?vue&type=script&lang=ts&"
import style0 from "./ApproveOrDeclineGrant.vue?vue&type=style&index=0&id=5bcd60ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcd60ea",
  null
  
)

export default component.exports